/**
 * Button names to be used for theme role overrides if required
 */
var ButtonName;
(function (ButtonName) {
    ButtonName["AddToBagButton"] = "addToBagButton";
    ButtonName["BagDrawerCheckoutButton"] = "bagDrawerCheckoutButton";
    ButtonName["BagDrawerViewBagButton"] = "bagDrawerViewBagButton";
    ButtonName["BagButton"] = "bagButton";
    ButtonName["EmptyBagMessageCardButton"] = "emptyBagMessageCardButton";
    ButtonName["ShareDialogButton"] = "shareDialogButton";
    ButtonName["CheckoutQuantityControl"] = "checkoutQuantityControl";
    ButtonName["MembershipButton"] = "membershipButton";
    ButtonName["ProfileButton"] = "profileButton";
    ButtonName["LocationMapSearchButton"] = "locationMapSearchButton";
    ButtonName["LocationMapSearchResultsButton"] = "locationMapSearchResultsButton";
    ButtonName["AddToBagModalButton"] = "addToBagModalButton";
})(ButtonName || (ButtonName = {}));
var DTCComponentName;
(function (DTCComponentName) {
    DTCComponentName["EmptyBagMessageCard"] = "emptyBagMessageCard";
})(DTCComponentName || (DTCComponentName = {}));

export { ButtonName, DTCComponentName };
//# sourceMappingURL=componentNames.js.map
